import React from 'react';
import type { ReactFCC } from '@bbkAdminUtils/utility-types';

export const NavCollapseContainer: ReactFCC = ({ children }) => (
  <div className="tw-pt-5">{children}</div>
);
